import { memo, useCallback, useEffect, useState } from "react";
import { SettingInfoCardProps } from "./types";
import { Button } from "ui/components/Button/Button";

import { classNames, getLanguageCurrentLocal, useTranslate } from "helpers";

import { Errors } from "services/forms/validation/types";
import {
  fetchLanguages,
  getLanguages,
} from "services/api/languages/redux";
import { useDispatch, useSelector } from "react-redux";
import {
  getSubscriptionPackageActiveAPI,
  getSubscriptionPackagesAPI,
  updateSubscriptionPackageActiveAPI,
} from "services/api/subscriptions/api";

import {
  Subscription,
  SubscriptionPackage,
} from "services/api/subscriptions/types";
import { initialSubscription } from "services/api/subscriptions/consts";
import { Language } from "services/api/languages/types";

const SettingInfoCard: React.FC<SettingInfoCardProps> = () => {

  const { t } = useTranslate();
  const dispatch = useDispatch();

  const languages = useSelector(getLanguages);
  const [subscriptionActive, setSubscriptionActive] =
    useState<Subscription>(initialSubscription);
  const [errors, setErrors] = useState<Errors>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [subscriptionPackages, setSubscriptionPackages] = useState<
    SubscriptionPackage[]
  >([]);

  useEffect(() => {
    //fetchSubscriptionPackages();
    //fetchSubscriptionPackageActive();
    dispatch(fetchLanguages() as any);
  }, [dispatch]);

  const fetchSubscriptionPackages = async () => {
    setIsLoading(true);

    let result;
    try {
      result = await getSubscriptionPackagesAPI();
    } catch {
      setIsLoading(false);
      return;
    }

    setSubscriptionPackages(result);
    setIsLoading(false);
    setErrors({});
  };

  const fetchSubscriptionPackageActive = async () => {
    setIsLoading(true);

    let result;
    try {
      result = await getSubscriptionPackageActiveAPI();
    } catch {
      setIsLoading(false);
      return;
    }
    if (result) {
      setSubscriptionActive(result);
      fetchSubscriptionPackageActive();
    }

    setIsLoading(false);
    setErrors({});
  };

  const handleSubscriptionPackageActiveClick = useCallback(
    async (e: any, id: string) => {
      e.preventDefault();
      await updateSubscriptionPackageActiveAPI(id);
    },
    []
  );

  const currentLanguage = getLanguageCurrentLocal();

  const isPackageActive = (currentId: string, activeId: string | undefined) => {
    let result = false;

    if (!currentId || !activeId) return result;

    if (currentId === activeId) {
      result = true;
    }

    return result;
  };

  return (
    <div className="rounded-sm">
      <div className="divide-y divide-slate-200 ">
        <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
          <div className="flex flex-col flex-1 max-w-[300px] ">
            <div>
              <p className="text-base font-bold text-slate-600  py-3  ">
                {t("admin.settinginfocard.detail.packages.title")}
              </p>
              <p className="text-sm">
                {t("admin.settinginfocard.detail.packages.description")}
              </p>
              <span className="text-xs">
                {t("admin.settinginfocard.detail.packages.description.price")}
              </span>
            </div>
          </div>
          <div className="flex flex-1 gap-4 px-3 my-3">
            {subscriptionPackages.map((item, index) => (
              <div
                key={index}
                className={classNames(
                  "border rounded-sm w-full max-w-[300px] p-6 flex flex-col",
                  isPackageActive(
                    item.id,
                    subscriptionActive?.subscriptionPackage?.id
                  )
                    ? "border-blue-600 bg-blue-100"
                    : "border-slate-200 bg-white"
                )}
              >
                <div className="flex justify-between">
                  <h2 className="text-2xl font-semibold mb-4">{item.name}</h2>
                  <span>
                    {" "}
                    {isPackageActive(
                      item.id,
                      subscriptionActive?.subscriptionPackage?.id
                    ) && (
                      <span className="text-xs font-semibold uppercase rounded-lg bg-yellow-300 border border-yellow-400 px-2 py-0.5  text-yellow-800">
                         {t("admin.settinginfocard.detail.packages.active")}
                      </span>
                    )}
                  </span>
                </div>
                <p className="text-base mb-3">{item.description}</p>
                <p className="mb-4">
                  <span className="text-xl font-bold">{item.price} €</span>/
                  <span className="xs">
                    {" "}
                    {t("admin.settinginfocard.detail.packages.month")}
                  </span>
                </p>
                <ul className="text-gray-600 mb-6 list-disc ml-4">
                  {/* {plan.features.map((feature, idx) => (
                    <li key={idx} className="mb-1 text-sm">
                      {feature}
                    </li>
                  ))} */}
                </ul>
                <Button
                  variant="primary"
                  size="full"
                  onClick={(e) =>
                    handleSubscriptionPackageActiveClick(e, item.id)
                  }
                >
                  {t("admin.settinginfocard.detail.packages.chooseplan")}
                </Button>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
          <div className="flex flex-col flex-1 max-w-[300px]">
            <div>
              <p className="text-base font-bold text-slate-600  py-3  ">
                {t("admin.settinginfocard.detail.languages.title")}
              </p>
              <p className="text-sm">
                {t("admin.settinginfocard.detail.languages.description")}
              </p>
            </div>
          </div>
          <div className="flex flex-1  px-3 my-3">
            <div className="rounded-sm bg-white border ">
              <div className="divide-y divide-slate-200 ">
                <div className=" min-h-[56px] min-w-[300px] divide-y">
                  {languages &&
                    languages?.items.map(
                      (language: Language, index: number) => {
                        return (
                          <div
                            className="flex items-center gap-3 px-3 py-2"
                            key={index}
                          >
                            <div className="">
                              <img
                                src={`/media/icons/flags/${language.id}.png`}
                                alt=""
                              />
                            </div>
                            <div className="flex justify-between w-full">
                              <div>{language.name}</div>
                              <div className="">
                                {language.id === currentLanguage && (
                                  <span className="text-xs font-semibold uppercase rounded-lg bg-yellow-300 border border-yellow-400 px-2 py-0.5  text-yellow-800">
                                    Zadani
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      }
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(SettingInfoCard);
